import { Navigate } from 'react-router-dom';
import { matchdayApi } from '@/api/endpoints';
import type { Matchday } from '@/api/types';
import { Alert, Card, Spinner } from '@/components/ui';
import { pickActiveMatchday } from '@/lib/matchday';
import { useAsync } from '@/lib/useAsync';

/** Menüpunkt "Tippabgabe": springt direkt zum aktuellen Spieltag (Reiter + Navigator dort). */
export function MatchdaysPage() {
  const { data, loading, error } = useAsync<Matchday[]>((signal) => matchdayApi.list(signal), []);

  if (loading) return <Spinner label="Spieltage werden geladen…" />;
  if (error) return <Alert>{error}</Alert>;

  const target = pickActiveMatchday(data ?? []);

  if (!target) {
    return (
      <Card>
        <p className="muted">Aktuell sind keine Spieltage veröffentlicht.</p>
      </Card>
    );
  }

  return <Navigate to={`/matchdays/${target.id}`} replace />;
}
